module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_8019.323d7f25.png";